const ACTIONS = {
  DIALOG_SHOW: 'DIALOG_SHOW',
  DIALOG_HIDE: 'DIALOG_HIDE',
  DIALOG_SET_PARAMS: 'DIALOG_SET_PARAMS',
};

export default ACTIONS;

const DIALOG_TYPES = {
  MODAL_TYPE_EXAMPLE: 'MODAL_TYPE_EXAMPLE',
  MODAL_CONFIRM_REGISTRATION: 'MODAL_CONFIRM_REGISTRATION',
  MODAL_VIDEO: 'MODAL_VIDEO',
  MODAL_REPORT_FORM: 'MODAL_REPORT_FORM',
  MODAL_SHARE_LINK: 'MODAL_SHARE_LINK',
  MODAL_CHANGE_PASSWORD: 'MODAL_CHANGE_PASSWORD',
  MODAL_VIDEO_SESSION_INVATION: 'MODAL_VIDEO_SESSION_INVATION',
  MODAL_CHANGE_USER_STATUS: 'MODAL_CHANGE_USER_STATUS',
  MODAL_UPLOAD_FILE: 'MODAL_UPLOAD_FILE',
  MODAL_CONFIRM_REMOVE: 'MODAL_CONFIRM_REMOVE',
  MODAL_VIDEO_SESSION_INVITE: 'MODAL_VIDEO_SESSION_INVITE',
  MODAL_CONTACT_CARD: 'MODAL_CONTACT_CARD',
  MODAL_INVITED_DECLINED: 'MODAL_INVITED_DECLINED',
  MODAL_ADD_CONTACTS: 'MODAL_ADD_CONTACTS',
  MODAL_LOADING: 'MODAL_LOADING',
  MODAL_VIDEO_POLL_RECORD_SAVING: 'MODAL_VIDEO_POLL_RECORD_SAVING',
  MODAL_VIDEO_POLL_RECORD_INVITE: 'MODAL_VIDEO_POLL_RECORD_INVITE',
};

export {DIALOG_TYPES};
